import { render } from "./IntroView.vue?vue&type=template&id=5cb010d7"
import script from "./IntroView.vue?vue&type=script&lang=js"
export * from "./IntroView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__